import { doc, onSnapshot } from 'firebase/firestore';
import { database } from './firebase';
import reload from '../util/reload';
import { thisOscarsYear } from './constants';

export let configureForceReload = () => {
  let lastForceReloadToken: undefined | string;

  onSnapshot(doc(database, 'objective_state', String(thisOscarsYear)), docSnap => {
    let currentForceReloadToken = docSnap.data()?.forceReloadToken;

    if (
      lastForceReloadToken !== undefined &&
      lastForceReloadToken !== currentForceReloadToken
    ) {
      reload();
    }

    lastForceReloadToken = currentForceReloadToken;
  });
};
